import styled from 'styled-components';

interface CardProps {
  borderColor?: string;
  color?: string;
}

export const Container = styled.div`
  width: 100%;
  margin-bottom: 20px;
  font-family: ${({ theme }) => theme.font.fontFamily.bold};
`;

export const BoxREsults = styled.div`
  display: flex;
  flex-direction: center;
  justify-content: center;
`;

export const Card = styled.div<CardProps>`
  width: 200px;
  border: 1.5px solid ${props => props.borderColor || 'transparent'};
  font-family: ${({ theme }) => theme.font.fontFamily.bold};
  font-weight: 100;
  margin: 5px;
  border-radius: 5px;

  p {
    font-size: 14px;
    text-align: center;
  }

  h3 {
    text-align: center;
  }

  .title {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #efefef;
    min-height: 50px;

    color: ${props => props.color};
  }

  .body {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 80px;

    p {
      font-size: 20px;
    }
    
  }
`;
